// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Readathon_loaderContainer__1i7cg","readathonContainer":"Readathon_readathonContainer__1vBQb","pageText":"Readathon_pageText__3U0lD"};